import * as Yup from "yup";

const AchievementSchema = (isEdit = false) => Yup.object().shape({
  amount: Yup
    .number()
    .label("Amount")
    .required(),
  icon: Yup.mixed().label("Icon").when([], {
    is: () => isEdit,
    then: (schema) => schema.nullable(),
    otherwise: (schema) => schema.required(),
  }),
});

export default AchievementSchema;
